<template>
  <div id="app">
    
    <router-view></router-view>

  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style lang="scss"> 
@import './sass/main.scss';

</style>



// WEBPACK FOOTER //
// src/App.vue